import { rivermeadowApi } from './api';

export const networkTroubleshootingApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        networkTroubleshooting: builder.mutation({
            query: (data) => ({
                url: '/networktroubleshootings',
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: data,
            }),
        }),
        getNetworkTroubleshootingStatus: builder.query({
            query: ({ id }) => ({
                url: `/networktroubleshootings/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

export const { useNetworkTroubleshootingMutation, useLazyGetNetworkTroubleshootingStatusQuery } =
    networkTroubleshootingApi;
